export const ASPECT_RATIO = 1.4145;export const ASPECT_RATIO = 1.4145;